import { Box, Paper, Tab, Tabs, Typography } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const TABS = [
  { to: '/merchant-subscriptions', label: 'التجار', end: true },
  { to: '/merchant-subscriptions/payments', label: 'طلبات الدفع' },
  { to: '/merchant-subscriptions/coupons', label: 'الكوبونات' },
  { to: '/merchant-subscriptions/settings', label: 'إعدادات الدفع' },
]

export default function SubscriptionsLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const current =
    TABS.find((tab) =>
      tab.end ? location.pathname === tab.to : location.pathname.startsWith(tab.to),
    )?.to || TABS[0].to

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ mb: 0.5 }}>
          اشتراكات التجار
        </Typography>
        <Typography color="text.secondary">
          إدارة التجار وطلبات الدفع والكوبونات من صفحات منفصلة أوضح.
        </Typography>
      </Box>
      <Paper sx={{ mb: 3, px: 1 }}>
        <Tabs
          value={current}
          onChange={(_, value) => navigate(value)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 56,
            '& .MuiTab-root': { minHeight: 56, fontWeight: 700 },
          }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.to} value={tab.to} label={tab.label} />
          ))}
        </Tabs>
      </Paper>
      <Outlet />
    </Box>
  )
}
